import { updatePlanningFilters, setKeyFilterSelected } from "../../../redux/actions/planningActions";
import connect from "react-redux/es/connect/connect";
import FilterPlanning from "../../../components/filter/FilterPlanning";

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.planning.filters ? state.planning.filters[ownProps.filterTargetKey] : [],
    currentFilters: state.planning.currentFilters ? state.planning.currentFilters[ownProps.filterTargetKey] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder,
    mode: ownProps.mode,
    maxItemsToDisplay: 1000,
    defaultValue: ownProps.defaultValue,
    allowClear: ownProps.allowClear
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updatePlanningFilters(ownProps.filterTargetKey, values));
    },

    setKeyFilterSelected: () => dispatch(setKeyFilterSelected(ownProps.filterTargetKey))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterPlanning);



// WEBPACK FOOTER //
// src/containers/activite/planning/FilterContainer.js